import { ActualsValueTypes } from '../../models/actualValueTypes'

import { getActualsValueTypeDefault } from './getActualsValueTypeDefault'

/**
 * Default AVT of the plan export (PDF, PPTX, JSON). It is not the P360 metric.
 *
 * The offering's `PDFActualsValueTypeDefault` from `AllProgramOfferingsJson` wins (Japan and China get Ndp
 * this way). Without it: reseller UTNet, distributor TNet, Retail program TNet.
 *
 * Sync with service-partner360/app/modules/partnerPlan/helpers/sectionSettings/getExportPlanActualsValueType.ts,
 * which picks the PDF metric by the same rule when nothing is saved.
 */
export const getActualsValueTypeExportPDFDefault = (
  pdfActualsTypeDefault: string | null | undefined,
  isRetailer: boolean,
  isDistributor: boolean
): ActualsValueTypes =>
  (pdfActualsTypeDefault as ActualsValueTypes) ||
  getActualsValueTypeDefault(isRetailer, isDistributor)
